export default __webpack_public_path__ + "10bd9275d70eb621d19393fd1cc78a64.png";